<div class="container">
  <div class="row">
    <div class="col-md-12">
      <h2 class="rounded text-center bg-warning text-dark">View Education Highlight</h2>
      <table class="table table-active ">
        <tbody>
        <p>Centre Details</p>
        <tr>
          <th> Student Name </th>
          <td>{{data.childName}}</td>
        </tr>
        <tr>
          <th> Follow Up </th>
          <td>{{data.followUpChild}}</td>
        </tr>
        <tr>
          <th> Unit Code </th>
          <td>{{data.unitCode}}</td>
        </tr>
        <tr>
          <th> Attendance </th>
          <td>{{data.present}}</td>
        </tr>

        <tr>
          <th> Centre Name </th>
          <td>{{data.centreName}}</td>
        </tr>
        <br>

        <p> Child Details </p>
        <tr>
          <th> Child Code </th>
          <td>{{data.childCode}}</td>
        </tr>
        <tr>
          <th> Gender </th>
          <td>{{data?.gender}}</td>
        </tr>
        <tr>
          <th> Subject </th>
          <td>{{data?.subject}}</td>
        </tr>

        <tr *ngIf="data.parentsName">
          <th> Parents Name </th>
          <td>{{data.parentsName}}</td>
        </tr>
        <br>

        <p> Session Details </p>
        <tr>
          <th> Session Date </th>
          <td>{{getDate(data?.sessionDate)}}</td>
        </tr>

        <tr>
          <th> Start Time </th>
          <td><span *ngIf="data?.startTime"> {{getTime(data?.startTime)}}</span></td>
        </tr>
        <tr>
          <th> End Time </th>
          <td><span *ngIf="data?.endTime">{{getTime(data?.endTime)}}</span></td>
        </tr>

        <tr>
          <th> Session Type </th>
          <td>{{data?.sessionType}}</td>

        </tr>
        <!--                <tr>-->
        <!--                    <th> VolunteerName </th>-->
        <!--                    <td>{{data?.volunteerName}}</td>-->

        <!--                </tr>-->
        <tr>
          <th> Topics Covered </th>
          <td>{{data?.topicsCovered}}</td>
        </tr>
        <tr>
          <th> Session Details </th>
          <td>{{data?.sessionDetails}}</td>
        </tr>


        <!*--------------------------------------------- BASELINE TABLE VALUES--------------------------------------------->
        <ng-container *ngIf="data.sessionType=='Baseline Assessment'"></ng-container>


        <tr>
          <th>Language Level</th>
          <td>{{data.languageLevel}}</td>
        </tr>
        <tr>
          <th>Maths Level</th>
          <td>{{data.mathsLevel}}</td>
        </tr>
        <tr>
          <th>EVS / Gk Level</th>
          <td>{{data.evsgkLevel}}</td>
        </tr>

        <tr>
          <th>Language Oral </th>
          <td>{{data.languageOral}}</td>
        </tr>
        <tr>
          <th>Language Written </th>
          <td>{{data.languageWritten}}</td>
        </tr>


        <tr>
          <th>Language Percentage </th>
          <td>{{ getLanguagePercentage(data.languageWritten,data.languageOral) }}</td>
        </tr>

        <tr>
          <th>Maths Oral </th>
          <td>{{data.mathsOral}}</td>
        </tr>
        <tr>
          <th>Maths Written </th>
          <td>{{data.mathsWritten}}</td>
        </tr>


        <tr>
          <th>Maths Percentage </th>
          <td>
            {{ getMathsPercentage(data.mathsWritten,data.mathsOral) }}
          </td>
        </tr>

        <tr>
          <th>EVS/GK Oral </th>
          <td>{{data.evsgkOral}}</td>
        </tr>
        <tr>
          <th>EVS/GK Written </th>
          <td>{{data.evsgkWritten}}</td>
        </tr>


        <tr>
          <th>EVS/GK Percentage </th>
          <td>{{
              getEvsGKPercentage(data.evsgkWritten,data.evsgkOral)}}</td>
        </tr>



        <tr>
          <th> Conducted By </th>
          <td>{{data?.submittedBy}}</td>
        </tr>
        <tr>

          <th> Conducted By (If by  Volunteer ) </th>

          <td>{{data?.volunteerName}}</td>

        </tr>



        <br>


        <p> Remark </p>
        <tr>
          <th> Remark </th>
          <td>{{data?.remark}}</td>
        </tr>
        </tbody>

      </table>
    </div>

<!--    <div class="col-md-12">-->
<!--      <h2 class="rounded  text-center bg-warning text-dark">Documents & Uploads</h2>-->
<!--      &lt;!&ndash;            <h3>Data will be uploaded to {{mStoragePath}} in {{mDbType}} at {{mPath}} </h3>&ndash;&gt;-->
<!--      <div class="col-md-6">-->
<!--        <app-file-upload [storagePath]="mStoragePath" [dbPath]="mPath" fileCount="multi"></app-file-upload>-->
<!--      </div>-->

<!--      <div class="cdk-virtual-scroll-data-source-example">-->
<!--        <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="5" class="example-viewport">-->
<!--          <div class="d-flex  flex-row">-->
<!--            <div *cdkVirtualFor="let d of (mDocuments);trackBy:trackByMethod;let i = index" class="example-item ">-->
<!--              <a (click)="openLink(d.url)">-->
<!--                <img [src]="d.url" style="width: 250px; height: 250px" class="img-thumbnail img-fluid">-->
<!--              </a>-->
<!--              <p style="flex-grow: 9; font-size: 14px" class="text-center">{{d.description}}</p>-->
<!--              <button mat-icon-button color="warn" (click)="deleteAdmissionFile(i,d,'documents')">-->
<!--                <mat-icon>delete</mat-icon>-->
<!--              </button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </cdk-virtual-scroll-viewport>-->
<!--      </div>-->
<!--      &lt;!&ndash;COPY&ndash;&gt;-->
<!--    </div>-->
    <!--        <div class="col-md-6">-->
    <!--      <prettyjson [obj]="documents$|async"></prettyjson>-->

  </div>
</div>




